import { useRoute } from 'shared/src/hooks/useRoute';
import type { SearchStackParamList } from '../../../Navigator';

export const useSearchRoute = <Key extends keyof SearchStackParamList>() =>
  useRoute<SearchStackParamList, Key>();
